import React, { Component } from 'react';
import { connect } from 'react-redux';
import QuickSearch from '../Components/QuickSearch';
import { query, setSearchQuery, toggleShowFullForm, handleKeyDown, setState } from '../Actions/QuickSearch.action';

const headerSearchIsOpenClass = 'search-is-open';

class QuickSearchContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {...props};
        this.clickHandler = this.clickHandler.bind(this);
        this.lastClickedNode = null;
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler);
    }

    componentWillUpdate({ showFullForm } = props) {
        if (this.state.showFullForm !== showFullForm) {
            this.setState({...this.state, showFullForm});
        }
    }

    clickHandler(event) {
        this.lastClickedNode = event.target;
    }

    onBlur() {
        const { showFullForm, toggleShowFullForm } = this.props;
        if (this.searchContainer && !this.searchContainer.contains(this.lastClickedNode)) {
            showFullForm && toggleShowFullForm();

            let body = document.querySelector('body');
            body.classList.remove('disable-scroll');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedItem !== prevProps.selectedItem) {
            document.querySelector('.quick-search-result__item--selected').scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
        }

        let body = document.querySelector('body');
        if (this.props.showFullForm) {
            body.classList.add('disable-scroll');

            this.props.isMuurikka ? this.props.muurikkaOpenActions() : this.props.haboOpenActions();
        } else {
            body.classList.remove('disable-scroll');
            this.props.isMuurikka ? this.props.muurikkaCloseActions() : this.props.haboCloseActions();
        }
    }

    render() {
        const { query } = this.props;
        const searchUrl = window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
        return (
            <div ref={(elem) => this.searchContainer = elem} className={this.props.className || ''} >
                <QuickSearch {...{...this.props, searchUrl, onBlur: () => this.onBlur() }} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        query: state.quickSearch.query,
        result: state.quickSearch.result,
        showResult: state.quickSearch.showResult,
        showFullForm: state.quickSearch.showFullForm,
        selectedItem: state.quickSearch.selectedItem,
        isLoading: state.quickSearch.isLoading
    }
}

let customDebouceTimeout = 0;
const mapDispatchToProps = dispatch => {
    return {
        onSearch: (text) => {
            dispatch(setSearchQuery(text));

            if (customDebouceTimeout) {
                clearTimeout(customDebouceTimeout);
            }

            customDebouceTimeout = setTimeout(() => {
                dispatch(query(text))
            }, 600);
        },
        clearSearchQuery: (text) => {
            dispatch(setState({
                showResult: false,
                query: ''
            }));
        },
        haboOpenActions: () => {
            let header = document.querySelector('header.header');
            if (!header) return;

            header.classList.add(headerSearchIsOpenClass);
        },
        haboCloseActions: () => {
            let header = document.querySelector('header.header');
            if (!header) return;

            header.classList.remove(headerSearchIsOpenClass);
        },
        muurikkaOpenActions: () => {
            let header = document.querySelector('header.header');
            if (!header) return;

            header.classList.add(headerSearchIsOpenClass);
        },
        muurikkaCloseActions: () => {
            let header = document.querySelector('header.header');
            if (!header) return;

            header.classList.remove(headerSearchIsOpenClass);
        },
        toggleShowFullForm: () => dispatch(toggleShowFullForm()),
        onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickSearchContainer);
